<section class="footer-area py-3" style="background-color: #000219;">
    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <div class="main-wrapper">
                    </div>

                </div>
            </div>



            </div>
        </div>
    </div>
</section>

<div class="copy-right"  style="background-color: #000219;">
    <div class="container text-white">
        <div class="copy-right-content">
            <p class="text-white">© DotBlack website is Proudly Owned by <a href="https://dotblack.co.za/" target="_blank" class="text-white">DotBlack</a></p>
        </div>
    </div>
</div>
